<template>
    <!-- Pills Filter -->
    <template v-if="departments.length < 11">
        <ul :class="[config.navDepartmentPillsClass, config.pillsVisibilityClass]"
            class="nav nav-pills nav-emp justify-content-center align-items-center mb-3"
            role="tablist">

            <li v-for="department in departments" class="nav-item" role="presentation">
                <a :class="[ activeDepartment && (department.id === activeDepartment.id) ? 'active' : '', config.navDepartmentLinkClass]"
                   class="nav-link"
                   type="button"
                   @click.prevent="activeDepartment = department">
                    {{ department.name }}
                </a>
            </li>
        </ul>
    </template>

    <div :class="[
             config.navDropdownClass,
             config.dropdownVisibilityClass ? config.dropdownVisibilityClass : (departments.length >= 11 ? 'd-flex' : 'd-flex d-lg-none')
             ]"
         class="dropdown nav-emp justify-content-center my-3"
    >
        <button :class="'btn-' + config.dropdownDepartmentClass"
                aria-expanded="false"
                class="btn dropdown-toggle"
                data-bs-toggle="dropdown"
                type="button"
        >
            {{ activeDepartment ? activeDepartment.name : 'Bitte wählen' }}
        </button>
        <ul class="dropdown-menu">
            <li v-for="department in departments">
                <a class="dropdown-item"
                   @click.prevent="activeDepartment = department"
                >
                    {{ department.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>

import {inject, onMounted, watch} from "vue";
import type EmployeeProvider from "../EmployeeProvider.ts";

interface Props {
    config: Object
}

const {
    config
} = defineProps<Props>();

const employeeProvider = inject<EmployeeProvider>("employeeProvider") as EmployeeProvider;

const departments = employeeProvider.getFilteredDepartmentsComputed();

const activeDepartment = employeeProvider.getActiveDepartmentRef();

watch(departments, (newValue) => {
    activeDepartment.value = newValue[0];
}, {
    immediate: true,
});

</script>
